
import { createSelector } from 'reselect'
import getHasSampledVariantDataSelector from 'modules/variant/redux/selectors/get-has-sampled-variant-data'
import needsToBeRatedSampleUtil from 'modules/variant/redux/selectors/needs-to-be-rated-sample/utils/index.js'

const needsToBeRatedSampleSelector = variantId => createSelector(
  getHasSampledVariantDataSelector(variantId),
  (hasSampledData) => {
    return needsToBeRatedSampleUtil(hasSampledData)
  }
)

export default needsToBeRatedSampleSelector
